import Show from '@components/helpers/Show'
import { clsx } from 'clsx'
import './index.scss'

interface Props<Item> {
    list: Item[]
    maxItemsToShow?: number
    renderItem: (item: Item) => TChild
}

const ExpandableList = <Item extends object>({
    list,
    maxItemsToShow = 5,
    renderItem,
}: Props<Item>) => {
    const [showMore, setShowMore] = useState(false)

    const shown = showMore ? list : list.slice(0, maxItemsToShow) ?? []

    return (
        <div className={clsx(['expandable-list', showMore && 'is-expanded'])}>
            <Show when={list.length > maxItemsToShow}>
                <span
                    className="show-more"
                    onClick={() => setShowMore(!showMore)}
                    data-testid={
                        showMore ? 'show-less-button' : 'show-more-button'
                    }
                >
                    {showMore ? 'Show less' : `Show all (${list.length})`}
                </span>
            </Show>

            <div
                className="expandable-list-items"
                data-testid="expandable-list-items"
            >
                {shown.map((item) => renderItem(item))}
            </div>
        </div>
    )
}

export default ExpandableList
